export default __webpack_public_path__ + "static/media/Fresher.fad33c4e.jpg";